import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
const PROVINCES = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Northwest Territories', 'Nunavut', 'Yukon'];
const INDUSTRIES = ['Technology', 'Retail', 'Healthcare', 'Construction', 'Professional Services', 'Manufacturing', 'Real Estate', 'Hospitality', 'Other'];
export function BusinessDetailsPage() {
  const navigate = useNavigate();
  const {
    business,
    updateBusiness
  } = useAuth();
  const [formData, setFormData] = useState({
    name: business?.name || '',
    industry: business?.industry || '',
    type: business?.type || '',
    province: business?.province || '',
    employees: business?.employees || '',
    hasWebsite: business?.hasWebsite || '',
    usesContracts: business?.usesContracts || ''
  });
  const handleNext = () => {
    updateBusiness(formData);
    navigate('/onboarding/business-readiness');
  };
  const handleBack = () => {
    navigate('/onboarding/business');
  };
  const isValid = formData.name && formData.type && formData.province;
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1209">
      <div className="sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-1210">
        <div className="mb-8" data-id="element-1211">
          <div className="flex justify-between items-center mb-2" data-id="element-1212">
            <span className="text-sm font-semibold text-primary" data-id="element-1213">
              Business Details
            </span>
            <span className="text-sm font-medium text-secondary" data-id="element-1214">Step 4</span>
          </div>
          <div className="w-full bg-borderColor rounded-full h-2" data-id="element-1215">
            <div className="bg-violetBlue h-2 rounded-full transition-all duration-300" style={{
            width: '85%'
          }} data-id="element-1216"></div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-1217">
          <div className="space-y-8" data-id="element-1218">
            <div data-id="element-1219">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1220">
                Business Name
              </label>
              <input type="text" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none" placeholder="e.g. Acme Corp" data-id="element-1221" />
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-1222">
              <div data-id="element-1223">
                <label className="block text-sm font-medium text-primary mb-2" data-id="element-1224">
                  Industry
                </label>
                <select value={formData.industry} onChange={e => setFormData({
                ...formData,
                industry: e.target.value
              })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none bg-white" data-id="element-1225">
                  <option value="" data-id="element-1226">Select industry</option>
                  {INDUSTRIES.map(i => <option key={i} value={i} data-id="element-1227">
                      {i}
                    </option>)}
                </select>
              </div>
              <div data-id="element-1228">
                <label className="block text-sm font-medium text-primary mb-2" data-id="element-1229">
                  Business Type
                </label>
                <select value={formData.type} onChange={e => setFormData({
                ...formData,
                type: e.target.value
              })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none bg-white" data-id="element-1230">
                  <option value="" data-id="element-1231">Select type</option>
                  <option value="Sole Proprietorship" data-id="element-1232">
                    Sole Proprietorship
                  </option>
                  <option value="Corporation" data-id="element-1233">Corporation</option>
                  <option value="Partnership" data-id="element-1234">Partnership</option>
                  <option value="Other" data-id="element-1235">Other</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-1236">
              <div data-id="element-1237">
                <label className="block text-sm font-medium text-primary mb-2" data-id="element-1238">
                  Province of Operation
                </label>
                <select value={formData.province} onChange={e => setFormData({
                ...formData,
                province: e.target.value
              })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none bg-white" data-id="element-1239">
                  <option value="" data-id="element-1240">Select province</option>
                  {PROVINCES.map(p => <option key={p} value={p} data-id="element-1241">
                      {p}
                    </option>)}
                </select>
              </div>
              <div data-id="element-1242">
                <label className="block text-sm font-medium text-primary mb-2" data-id="element-1243">
                  Number of Employees
                </label>
                <select value={formData.employees} onChange={e => setFormData({
                ...formData,
                employees: e.target.value
              })} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none bg-white" data-id="element-1244">
                  <option value="" data-id="element-1245">Select size</option>
                  <option value="Just me" data-id="element-1246">Just me</option>
                  <option value="1-5" data-id="element-1247">1-5</option>
                  <option value="6-25" data-id="element-1248">6-25</option>
                  <option value="26-100" data-id="element-1249">26-100</option>
                  <option value="100+" data-id="element-1250">100+</option>
                </select>
              </div>
            </div>

            <div data-id="element-1251">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1252">
                Does the business have a website?
              </label>
              <div className="flex gap-4" data-id="element-1253">
                {['Yes', 'No'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                hasWebsite: option
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.hasWebsite === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1254">
                    {option}
                  </button>)}
              </div>
            </div>

            <div data-id="element-1255">
              <label className="block text-sm font-medium text-primary mb-2" data-id="element-1256">
                Does the business use written contracts?
              </label>
              <div className="flex gap-4" data-id="element-1257">
                {['Yes', 'No', 'Some'].map(option => <button key={option} onClick={() => setFormData({
                ...formData,
                usesContracts: option
              })} className={`flex-1 py-3 px-4 rounded-lg border ${formData.usesContracts === option ? 'border-violetBlue bg-aliceBlue text-violetBlue font-semibold' : 'border-borderColor text-primary hover:bg-aliceBlue'} transition-colors`} data-id="element-1258">
                    {option}
                  </button>)}
              </div>
            </div>
          </div>

          <div className="mt-10 flex justify-between gap-4" data-id="element-1259">
            <button onClick={handleBack} className="flex items-center px-6 py-3 border border-borderColor rounded-lg text-sm font-semibold text-primary hover:bg-aliceBlue transition-colors" data-id="element-1260">
              <ChevronLeft className="w-4 h-4 mr-1" data-id="element-1261" /> Back
            </button>
            <button onClick={handleNext} disabled={!isValid} className="flex items-center px-8 py-3 bg-violetBlue text-white rounded-lg text-sm font-semibold hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity" data-id="element-1262">
              Next <ChevronRight className="w-4 h-4 ml-1" data-id="element-1263" />
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}